import { Input, Injectable } from '@angular/core';
import { IComponentData } from '../shared.definitions';

@Injectable()
export abstract class BaseComponent {
  @Input() component: IComponentData;
  @Input() componentObject: any;
  @Input() extraData: any;
}
